const PAYMENT_METHODS = [
  { text: 'Panel Banker', value: 'referred_banker' },
  { text: 'Preferred Banker', value: 'own_banker' },
  { text: 'Cash Buyer', value: 'cash' },
  { text: 'Government Loan', value: 'government_loan' },
  { text: 'Staff Loan', value: 'staff_loan' },
  { text: 'Rent-To-Own', value: 'rent_to_own' },
];
export default PAYMENT_METHODS;

export const PAYMENT_METHOD_PANEL_BANKER = 'referred_banker';
export const PAYMENT_METHOD_PREFERRED_BANKER = 'own_banker';
export const PAYMENT_METHOD_CASH_BUYER = 'cash';
export const PAYMENT_METHOD_GOVERNMENT_LOAN = 'government_loan';
export const PAYMENT_METHOD_STAFF_LOAN = 'staff_loan';
export const PAYMENT_METHOD_RENT_TO_OWN = 'rent_to_own';
export const PAYMENT_METHOD_BANK_LOAN = 'bank_loan';

// CPI-974 (D2/S1): Vietnam-only source-of-finance option. Deliberately NOT a member of
// PAYMENT_METHODS: that array is the un-gated fallback OPTION list for the Booking Overview
// Source-of-finance select (containers/Bookings/Overview/Info.jsx), so an entry here would be
// selectable in Malaysia - and book-api migration 0526 has made 'bank_loan' a valid FK target,
// so it would persist. Options are assembled per country by utils/vietnam.js
// paymentMethodOpts(auth); this object is the only source of the VN entry.
export const PAYMENT_METHOD_BANK_LOAN_OPTION = { text: 'Bank Loan', value: PAYMENT_METHOD_BANK_LOAN };

// Label-only lookup table: every payment-method value the app can render a name for, including
// the Vietnam-only ones. NEVER use this as an option list - use paymentMethodOpts(auth).
export const PAYMENT_METHOD_LABELS = [
  ...PAYMENT_METHODS,
  PAYMENT_METHOD_BANK_LOAN_OPTION,
];



// WEBPACK FOOTER //
// ./src/constants/paymentMethods.js